import React from "react";
import Loadable from "../../react-loadable";

const WeaDateSwitch = Loadable({
  loader: () => import("./DateSwitch"),
  loading: () => null,
  render: (obj, props, ref) => {
    if (obj) {
      return React.createElement(obj && obj.__esModule ? obj.default : obj, {
        ...props,
        ref
      });
    }
    return null;
  }
});
export default WeaDateSwitch;



// WEBPACK FOOTER //
// ./ecology9/wea-date-switch/index.js